import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
var variantStyles = {
    line: {
        tabs: 'vas-gap-2',
        tab: 'vas-border-b-4 vas-border-transparent vas-p-2',
        tabSelected: 'vas-border-b-4 vas-border-primary',
    },
    enclosed: {
        tab: 'vas-py-2 vas-px-4 vas-rounded-t',
        tabSelected: 'vas-border vas-bg-gray-100 vas-border-b-0',
    },
};
function Tab(_a) {
    var children = _a.children, index = _a.index, selectedTab = _a.selectedTab, handleSelect = _a.handleSelect, variant = _a.variant;
    var isSelected = selectedTab === index;
    var className = "".concat(variantStyles[variant].tab, " ").concat(isSelected ? variantStyles[variant].tabSelected : '');
    return (_jsx("button", { type: 'button', className: className, onClick: function () { return handleSelect(index); }, children: children }));
}
export function TabPanel(_a) {
    var children = _a.children, className = _a.className;
    return _jsx("div", { className: className, children: children });
}
function TabPanels(_a) {
    var children = _a.children, selectedTab = _a.selectedTab, variant = _a.variant;
    return React.Children.map(children, function (child, index) {
        var _a;
        if (!child)
            return null;
        var className = child.props.className
            ? "".concat(child.props.className, " ").concat((_a = variantStyles[variant].tabPanel) !== null && _a !== void 0 ? _a : '')
            : variantStyles[variant].tabPanel;
        if (index === selectedTab && child.type === TabPanel) {
            return _jsx(TabPanel, { className: className, children: child.props.children });
        }
        return null;
    });
}
export function Tabs(_a) {
    var tabs = _a.tabs, _b = _a.variant, variant = _b === void 0 ? 'line' : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, onTabChange = _a.onTabChange, children = _a.children;
    var _d = useState(tabIndex), selectedTab = _d[0], setSelectedTab = _d[1];
    var handleSelect = useCallback(function (index) {
        setSelectedTab(index);
        if (onTabChange) {
            onTabChange(index);
        }
    }, [onTabChange]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vas-flex vas-flex-wrap vas-items-center vas-justify-between', children: [_jsx("div", { className: "vas-flex vas-flex-wrap ".concat(variantStyles[variant].tabs), children: tabs.map(function (tab, index) { return (_jsxs(React.Fragment, { children: [index !== 0 && variant === 'line' && (_jsx("div", { className: 'vas-my-2 vas-h-auto vas-w-0.5 vas-bg-gray-300' })), _jsx(Tab, { index: index, selectedTab: selectedTab, handleSelect: handleSelect, variant: variant, children: tab.label })] }, "tab-".concat(tab.label))); }) }), _jsx("div", { className: 'vas-flex vas-flex-wrap', children: tabs.map(function (tab, index) {
                            return tab.secondaryAction &&
                                selectedTab === index && (_jsx("div", { className: 'vas-secondary-action', children: tab.secondaryAction }, "tab-secondary-action-".concat(tab.label)));
                        }) })] }), _jsx(TabPanels, { selectedTab: selectedTab, variant: variant, children: children })] }));
}
